import { isOfType } from 'common/helpers'
import type { WellId } from 'common/types'

import type { FieldId, ProjectVspId, VspId } from './types'

export type ProjectWellVsp = {
  wellId: WellId
  wellName: string
  fieldId: FieldId
  vspList: ProjectVsp[]
}

export type ProjectVsp = {
  id: ProjectVspId
  vspId: VspId
  vspName: string
  isActive: boolean
  offset: string
}

export type VspData = {
  vspId: ProjectVsp['vspId']
  wellIds: WellId[]
}

const FilterTypeArray = ['vsp', 'no_vsp', 'all'] as const
export type FilterType = (typeof FilterTypeArray)[number]

export const isFilterType = isOfType(FilterTypeArray)
